// @module Ames.CheckoutUrl.CheckoutUrl
define("Ames.CheckoutUrl.CheckoutUrl.View", [
  "ames_checkouturl_checkouturl.tpl",
  "Backbone",
  "Utils"
], function (ames_checkouturl_checkouturl_tpl, Backbone, Utils) {
  "use strict";

  // ---------------------------------------------------------------------
  // Configuration
  // ---------------------------------------------------------------------
  // Where to send the shopper once the cart is built. '/cart' lets them
  // review items + applied promo, then choose guest checkout. Switch to
  // '/checkout' if you want to drop them straight into checkout (confirm
  // guest checkout is enabled and doesn't force login first).
  var CART_PATH = "/cart";
  var CLEAR_CART_FIRST = true; // Meta best practice #1
  var CHECKOUT_PATH = "https://www.shopamestools.com/scs/checkout.ssp?is=checkout#shipping/address"

  // ---------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------

  // Read a query param from the URL. Prefers the standard query string;
  // falls back to a hash fragment in case the app is on hash-based routing.
  function getQueryParam(name) {
    var search = window.location.search;

    if (!search && window.location.hash.indexOf("?") > -1) {
      search = window.location.hash.substring(
        window.location.hash.indexOf("?"),
      );
    }

    if (!search) {
      return null;
    }

    try {
      // URLSearchParams decodes %3A / %2C automatically.
      return new URLSearchParams(search).get(name);
    } catch (e) {
      var re = new RegExp("[?&]" + name + "=([^&]*)");
      var m = re.exec(search);
      return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : null;
    }
  }

  // "12345:3,23456:1" -> [{ quantity: 3, item: { internalid: 12345 } }, ...]
  // IDs must be NetSuite item internal IDs (matrix CHILD ids for matrix items).
  function parseProducts(raw) {
    var lines = [];
    if (!raw) {
      return lines;
    }

    raw.split(",").forEach(function (entry) {
      var parts = entry.split(":");
      if (parts.length !== 2) {
        return;
      }

      var id = parseInt(String(parts[0]).replace(/[^0-9]/g, ""), 10);
      var qty = parseInt(parts[1], 10);

      if (!id || !qty || qty < 1) {
        return;
      }

      lines.push({ quantity: qty, item: { internalid: id } });
    });

    return lines;
  }

  // Wrap SuiteCommerce jQuery deferreds as native promises so we get
  // reliable .then / .catch chaining regardless of the jQuery version.
  function toPromise(deferred) {
    return Promise.resolve(deferred);
  }

  // @class Ames.CheckoutUrl.CheckoutUrl.View @extends Backbone.View
  return Backbone.View.extend({
    template: ames_checkouturl_checkouturl_tpl,

    initialize: function (options) {
      this.status =
        Utils && Utils.translate
          ? Utils.translate("Preparing your cart\u2026")
          : "Preparing your cart\u2026";

      this.buildCart();
    },

    events: {},
    bindings: {},
    childViews: {},

    // Remove every line currently in the cart so Meta carts start clean.
    clearCart: function () {
      var cart = this.cart;

      if (!CLEAR_CART_FIRST || !cart || typeof cart.getLines !== "function") {
        return Promise.resolve();
      }

      return toPromise(cart.getLines()).then(function (lines) {
        if (!lines || !lines.length) {
          return;
        }

        var removals = lines.map(function (line) {
          return toPromise(cart.removeLine({ line_id: line.internalid }));
        });

        return Promise.all(removals);
      });
    },

    // Add all parsed lines. Uses addLines() when available (SC 2021.1+),
    // otherwise falls back to sequential addLine() calls.
    addAllLines: function (products) {
      var cart = this.cart;

      if (typeof cart.addLines === "function") {
        return toPromise(cart.addLines({ lines: products }));
      }

      return products.reduce(function (chain, line) {
        return chain.then(function () {
          return toPromise(cart.addLine({ line: line }));
        });
      }, Promise.resolve());
    },

    buildCart: function () {
      var self = this;
      var cart = this.cart;
      var products = parseProducts(getQueryParam("products"));
      var coupon = getQueryParam("coupon");

      // Fail safe: no cart component or nothing to add -> just go to cart.
      if (!cart || !products.length) {
        window.location.href = CART_PATH;
		// window.location.href = CHECKOUT_PATH;
        return;
      }

      this.clearCart()
        .then(function () {
          return self.addAllLines(products);
        })
        .then(function () {
          if (!coupon) {
            return;
          }

          // Don't let an invalid/expired coupon block the trip to cart.
          return toPromise(cart.addPromotion({ promocode: coupon })).then(
            function () {
              /* applied */
            },
            function (err) {
              if (window.console) {
                console.warn("Meta coupon could not be applied:", coupon, err);
              }
            },
          );
        })
        .then(function () {
        //   window.location.href = CART_PATH;
		window.location.href = CHECKOUT_PATH;
        })
        .catch(function (err) {
          if (window.console) {
            console.error("Meta checkout build failed:", err);
          }
          // Send them to the cart anyway rather than a dead end.
          window.location.href = CART_PATH;
        });
    },

    //@method getContext @return Ames.CheckoutUrl.CheckoutUrl.View.Context
    getContext: function getContext() {
      //@class Ames.CheckoutUrl.CheckoutUrl.View.Context
      return {
        message: this.status || "Preparing your cart\u2026",
      };
    },
  });
});

// https://www.shopamestools.com/scs/shopping-local.ssp#checkout-url?products=15188:3,25029:1&coupon=TTUNION
